import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { FunctionsService } from './functions.service';
import { COMPUTER_ID } from '@shared/data-structure/computer-id';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActiveSessionService {

  constructor(
    private http: HttpClient,
    private functions: FunctionsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  // Este servicio se usa para dos propósitos:
  // Para crear un broserId y otorgar N impresiones/citas a ciertas entidades por computador (creado para Nayibe)
  // Para crear un sessionId y validar que no haya una misma cuenta leyendo obras en dos computadores a la vez

  getSessionToken(): string {
    const isBrowser = isPlatformBrowser(this.platformId);
    if (!isBrowser) {
      return this.functions.generateRandomString(10);
    }

    let sessionId = localStorage.getItem(COMPUTER_ID);
    if (!sessionId) {
      sessionId = this.functions.generateRandomString(10);
      localStorage.setItem(COMPUTER_ID, sessionId);
    }

    return sessionId;
  }

  closeAllSessions(): Observable<any> {
    return this.http.post(`${environment.URL_API_AV}/api/active-session/close-all`, {});
  }

}
